<section>
    <img *ngIf="type=='list'" src="../../../assets/images/New design/empty-list.png" alt="empty list">
    <img *ngIf="type=='mail'" src="../../../assets/images/New design/empty-mail.png" alt="empty mail">
    <h5 *ngIf="title" [ngClass]="{'white': color === 'white'}">{{title}}</h5>
    <p *ngIf="description" [ngClass]="{'white': color === 'white'}">{{description}}.</p>
</section>
